import React from 'react';
import PropTypes from 'prop-types';
import './style.less';

let dv = null;
class LineUpDrag extends React.Component {
  static propTypes = {
    index: PropTypes.number,
    item: PropTypes.object,
    mouseup: PropTypes.func,
    type: PropTypes.string,
    handleSounds: PropTypes.func,
  };

  state = {
    x: 0,
    y: 0,
    isDragging: false,
    offsetY: 0,
    offsetX: 0,
  }

  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    this.removeEvent();
  }

  init = () => {
    dv = document.getElementById(`dragDiv${this.props.index}`);
    this.setState({
      x: dv.offsetLeft,
      y: dv.offsetTop,
    }, () => {
      this.addEvent();
    });
  }

  addEvent = () => {
    const { index } = this.props;
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
      document.getElementById(`dragDiv${index}`).addEventListener('touchstart', this.startDrag);
      window.addEventListener('touchmove', this.dragging);
      window.addEventListener('touchend', this.endDrag);
    } else {
      document.getElementById(`dragDiv${index}`).addEventListener('mousedown', this.startDrag);
      window.addEventListener('mousemove', this.dragging);
      window.addEventListener('mouseup', this.endDrag);
    }
  };

  removeEvent = () => {
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
      window.removeEventListener('touchmove', this.dragging);
      window.removeEventListener('touchend', this.endDrag);
    } else {
      window.removeEventListener('mousemove', this.dragging);
      window.removeEventListener('mouseup', this.endDrag);
    }
  };

  startDrag = (e) => {
    e.stopPropagation();
    this.setState({
      x: e.currentTarget.offsetLeft - document.querySelector('.option-list').scrollLeft,
      y: e.currentTarget.offsetTop,
    });
    // 给阴影设置宽高
    dv = e.currentTarget;
    this.timer = setTimeout(() => {
      if (dv.parentNode.className !== 'finished') {
        this.props.handleSounds();
        let touch = null;
        if (e.touches) {
          touch = {
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY,
          };
        } else {
          touch = e;
        }
        !dv.className.includes(' line-up-drag') && (dv.className += ' line-up-drag');
        document.querySelector('.option-list').style.overflow = 'hidden';
        // 获取左部和顶部的偏移量
        const offsetX = touch.clientX - dv.offsetLeft;
        const offsetY = touch.clientY - dv.offsetTop;
        this.setState({
          isDragging: true,
          offsetX,
          offsetY,
        });
      }
    }, 300);
  };

  dragging = (e) => {
    clearInterval(this.timer);
    const { isDragging, offsetX, offsetY } = this.state;
    if (isDragging) {
      let touch = null;
      if (e.touches) {
        touch = {
          clientX: e.touches[0].clientX,
          clientY: e.touches[0].clientY,
        };
      } else {
        touch = e;
      }
      const x = touch.clientX - offsetX;
      const y = touch.clientY - offsetY;
      this.setState({ x, y });
    }
  };

  endDrag = () => {
    clearInterval(this.timer);
    const {
      isDragging,
      x,
      y,
    } = this.state;
    if (isDragging) {
      dv.className = dv.className.replace('down', '');
      this.setState({
        isDragging: false,
      }, () => {
        this.props.mouseup(dv, x, y);
      });
    }
    document.querySelector('.option-list').style.overflow = 'auto';
  };

  render() {
    const { index, item, type } = this.props;
    return (
      <div
        className={`line-up-drag-${type}`}
        id={`dragDiv${index}`}
        style={{ left: this.state.x, top: this.state.y }}
        data-val={item.val}
      >
        {type === 'txt'
          ? <div>{item.txt}</div>
          : <img src={item.img} alt="" />
        }
      </div>
    );
  }
}


export default React.memo(LineUpDrag);
